import React from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getFromLocalStorage, buildGameLaunchUrl } from "../../services/helper/cl_Helper";
import icons from "../../assets/images/sprite-other-icons.svg";
import statickImg from "../../assets/images/popup/staticImg.webp";
import { setGameDetails, setGamePopup } from "../crashGames/cl_CrashSlice";
import useFilterGamesByType from "../../services/helper/filterGamesByType";
import { setHomePopUp } from "../signIn/cl_SignInSlice";

const GameCategorySection = ({
  categoryName,
  iconName,
  maxGames = 10,
  onViewAll,
}) => {
  const filterByGameType = useFilterGamesByType();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filteredGames = filterByGameType(categoryName);
  const sliedGames = filteredGames[0]?.game?.slice(0, maxGames) || [];

  const handleViewAll = () => {
    const token = getFromLocalStorage("gk");
    const gamesList = filteredGames[0]?.game || [];

    localStorage.setItem(
      "categoryGames",
      JSON.stringify({
        categoryName,
        gamesList,
        title: categoryName,
        game_type: categoryName,
      })
    );

    if (!token) {
      localStorage.setItem(
        "intendedViewAll",
        JSON.stringify({
          categoryName,
          gamesList,
          type: "viewAll",
        })
      );
      navigate("/signin");
      return;
    }

    navigate(`/games/${categoryName}`, {
      state: {
        gamesList,
        title: categoryName,
        game_type: categoryName,
      },
    });
  };

  const navigateToGamePopup = (game) => {
    const token = getFromLocalStorage("gk");
    if (token) {
      const url = buildGameLaunchUrl(game, { gameClose: true });
      window.location.href = url;
    } else {
      localStorage.setItem(
        "pendingGame",
        JSON.stringify(game) 
      );
      navigate("/signin");
    }
  };

  if (!sliedGames.length) {
    return null;
  }

  return (
    <div className="SB-gameCategory-section SB-liveCasino">
      <div className="SB-casinoCategoryItem">
        <div className="SB-casinoCategoryItem-header">
          <div className="SB-iconSVG">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <use xlinkHref={`${icons}#${iconName}`} />
            </svg>
          </div>
          <div className="SB-casinoCategoryItem-title">
            {categoryName}{" "}
            <span className="SB-casinoCategory-gamescount">
              ({filteredGames[0]?.game?.length || 0})
            </span>
          </div>
          <button
            onClick={handleViewAll}
            className="SB-viewAll-button"
            style={{ backgroundColor: "var(--color-bg-surface)", border: 0 }}
          >
            <div className="SB-viewAll">
              View All
              <div className="SB-iconSVG">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#FFF"
                >
                  <use xlinkHref={`${icons}#icon-angle-arrow-right`} />
                </svg>
              </div>
            </div>
          </button>
        </div>
          <>
            <Splide
              className="SB-splide-liveCasino SB-casinoGamesList"
              hasTrack={false}
              options={{
                type: "slide",
                pagination: false,
                autoplay: true,
                autoWidth: true,
                arrows: false,
                lazyLoad: "sequential",
              }}
            >
              <SplideTrack>
                {sliedGames.map((game, index) => (
                  <SplideSlide key={index}>
                    <div
                      className="SB-casinoGameItem SB-livecasinoGameItem"
                      onClick={() => navigateToGamePopup(game)}
                    >
                      <div className="SB-casinoGameItem-container">
                        <img
                          src={
                            (game?.image?.configurl || game?.image?.url) ===
                            "NoIcon"
                              ? statickImg
                              : game?.image?.configurl ||
                                game?.image?.url ||
                                statickImg
                          }
                          data-splide-lazy={
                            (game?.image?.configurl || game?.image?.url) ===
                            "NoIcon"
                              ? statickImg
                              : game?.image?.configurl ||
                                game?.image?.url ||
                                statickImg
                          }
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = statickImg;
                          }}
                        />
                        <div className="SB-casinoGameItem-playGame-container">
                          <div className="SB-btnPlayGame">
                            <div className="SB-iconSVG">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="#FFF"
                              >
                                <use xlinkHref={`${icons}#icon-casino-play`} />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="SB-casinoGameItem-footer">
                        <div className="SB-casinoGameTitle">
                          {game?.name
                            ? game.name.charAt(0).toUpperCase() +
                              game.name.slice(1).toLowerCase()
                            : ""}
                        </div>
                        <div className="SB-casinoGameSubTitle">
                          {game?.provider === "split_the_pot"
                            ? "Stp"
                            : game?.provider === "turbogames"
                            ? "Turbo"
                            : game?.provider}
                        </div>
                      </div>
                    </div>
                  </SplideSlide>
                ))}
              </SplideTrack>
            </Splide>
          </>
      </div>
    </div>
  );
};

export default GameCategorySection;
